// extracted by mini-css-extract-plugin
export default {"base":"DropZoneUi_base__eh-58","icon":"DropZoneUi_icon__SjSW+","title":"DropZoneUi_title__eEBL1"};